import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";

import { TenantGate } from "@/components/TenantGate";
import { TooltipProvider } from "@/components/ui/tooltip";
import { queryClient } from "@/lib/query";
import { router } from "@/router";
import { ThemeProvider } from "@/theme/ThemeProvider";

export function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        {/* TooltipProvider once at the root so any Tooltip in the tree
            shares the same delay-timer + hover state. Radix requires
            exactly one provider per tree; the alternative (provider
            per Tooltip) blows up animation timing. */}
        <TooltipProvider delayDuration={150}>
          {/* Tenant guard: an unknown tenant subdomain shows a 404, not a login
              that would silently land on `public` (ADR-0036 item #6). */}
          <TenantGate>
            <RouterProvider router={router} />
          </TenantGate>
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
